import { TLibraryMethod } from '@monorepo/types';
import { ModifiersZTableModel } from '../../table.modifier';

export const METHODS_LIST_TABLE_MODEL = {
  createModel: (items: TLibraryMethod[]) => {
    return ModifiersZTableModel.createTableModel(
      items,
      {
        headerConfig: [
          { type: 'TEXT_CELL', text: 'Method Code' },
          { type: 'TEXT_CELL', text: 'Product Type' },
          { type: 'TEXT_CELL', text: 'Operation Name' },
          { type: 'TEXT_CELL', text: 'Part' },
          { type: 'TEXT_CELL', text: 'Machine' },
          { type: 'TEXT_CELL', text: 'Status' },
          { type: 'TEXT_CELL', text: 'TST' },
          { type: 'TEXT_CELL', text: 'SAM' },
          { type: 'TEXT_CELL', text: '', stickyType: 'RIGHT', widthInPx: 50 },
        ],
      },
      (item) => {
        return {
          type: 'ROW',
          rowItem: item,
          cells: [
            { type: 'TEXT_CELL', text: item.code, href: `/library/methods/${item.id}` },
            { type: 'TEXT_CELL', text: item.productTypeName },
            { type: 'TEXT_CELL', text: item.operationName },
            { type: 'TEXT_CELL', text: item.partName },
            { type: 'TEXT_CELL', text: item.machineName },
            { type: 'TEXT_CELL', text: item.status },
            { type: 'TEXT_CELL', text: item.tstValue },
            { type: 'TEXT_CELL', text: item.samValue },
            {
              type: 'ACTION_LIST_CELL' as const,
              title: '',
              actions: [
                { displayText: 'View', type: 'VIEW' },
                { displayText: 'Edit', type: 'EDIT' },
              ],
            },
          ],
        };
      },
    );
  },
};
